import { textAlignDropdownPlugin } from './plugin'

export const initTextAlignDropdownPlugin = () => {
  if (CKEDITOR.plugins.get('textaligndropdown')) {
    return
  }

  CKEDITOR.plugins.add('textaligndropdown', textAlignDropdownPlugin)
}
